// @flow @jsx h
/* eslint-disable jsx-a11y/label-has-for,compat/compat */
/* eslint-disable promise/always-return */

import { Component, h } from 'preact'

/* styles */
import styles from './index.css'
import appStyles from '../App.css'

/* types */
import type { Tag } from '../types'
import { connect } from '../../../lib/provider'

function createUrl (tag: ?Tag) {
  return tag ? `#/filter/${tag.slug}` : '#/'
}

type Props = {
  tags: Tag[],
  filter: string,
  sendGaEvent: any => void
}

type State = {
  showAllTags: boolean
}

class _TagList extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      showAllTags: false
    }
  }

  handleShowMore = (e) => {
    this.setState({ showAllTags: true })
  }

  handleClickTag = (e) => {
    this.props.sendGaEvent &&
    this.props.sendGaEvent({
      action: 'SELECT_FILTER',
      label: e.target.text
    })
  }

  render () {
    const { tags, filter } = this.props
    const { showAllTags } = this.state
    const showAllQuestions = !filter

    const spor = Object.values(tags)
      .filter(tag => tag.category === 'spor')
      .sort((a, b) => b.count - a.count)

    const personer = Object.values(tags)
      .filter(tag => tag.category === 'person')
      .sort((a, b) => b.count - a.count)

    let displayTags
    if (!showAllTags) {
      displayTags = spor.filter((tag, idx) => idx < 10)
    } else {
      displayTags = [...spor, ...personer]
    }

    return (
      <div class={styles.tagWrapper + ' ' + appStyles.app__element}>
        <h2>Emner</h2>
        <div>
          {
            displayTags.map(tag => {
              const active = tag.slug === filter
              return <a
                key={tag.slug}
                href={createUrl(tag)}
                className={`nrk-button ${active ? styles.orderudInverted : ''} ${styles.tag} `}
                aria-pressed={active.toString()}
                role='button'
                onClick={this.handleClickTag}>
                {tag.text}
              </a>
            })
          }
          {!showAllTags && (
            <button class='nrk-button ' aria-label='Vis flere' onClick={this.handleShowMore}>&hellip;</button>
          )}
        </div>
        <div>
          <a
            href={createUrl(null)}
            class={`${styles.viewAll} nrk-button ${showAllQuestions ? styles.orderudInverted : ''}`}
            aria-pressed={showAllQuestions.toString()}
            role='button'>
            Se alle spørsmål og svar
          </a>
        </div>
      </div>
    )
  }
}

const connector = connect()
export const TagList = connector(_TagList)
